import { useMemo } from "react";
import { useSelector } from "react-redux";

const useWillInfo = () => {
  const {
    auth: { hasPartner, country, hasChildren, hasOtherChildren },
    basic,
    family,
    guardian: {
      petGuardian,
      alternatePetGuardian,
      childGuardian,
      alternateChildGuardian,
    },
    distribution,
    executor,
    poa,
    poaCare,
  } = useSelector((store) => store);
  return useMemo(
    () => ({
      basicInfo: {
        ...basic,
        country,
        hasChildren,
        hasOtherChildren,
      },
      family: {
        ...family,
        hasPartner,
      },
      petGuardian,
      alternatePetGuardian,
      childGuardian,
      alternateChildGuardian,
      distribution,
      executor,
      poaAttorney: poa,
      poaCare,
    }),
    [
      basic,
      family,
      country,
      hasChildren,
      hasOtherChildren,
      hasPartner,
      petGuardian,
      alternatePetGuardian,
      childGuardian,
      alternateChildGuardian,
      distribution,
      executor,
      poa,
      poaCare,
    ],
  );
};

export default useWillInfo;
